import { request } from "./client.js";
import { E } from "./endpoints.js";
import type { WalletTransactionListResponse } from "../types/wallet.js";

/**
 * GET /v1/lk/wallet/transactions
 * Returns paginated transaction history.
 * NOTE: backend endpoint pending — UI shows empty state gracefully until implemented.
 */
export async function listTransactions(
  limit = 20,
  cursor?: string,
): Promise<WalletTransactionListResponse> {
  return request<WalletTransactionListResponse>(E.lk.walletTransactions, {
    query: { limit, ...(cursor ? { cursor } : {}) },
  });
}

// NOTE: online self-topup (Telegram Stars) was retired on 2026-06-17. The
// backend endpoint POST /v1/lk/wallet/topup/stars now responds 410 Gone.
// Balance top-ups are performed manually by an administrator, so the LK UI no
// longer exposes a self-service topup call. The `walletTopupStars` endpoint
// constant and `WalletTopupStarsResponse` type are intentionally kept in place
// to document the (now-disabled) API surface.
